import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import AddPhase from '../Modal/AddPhase/AddPhase'; // Ensure this path is correct
import ConfirmDeleteModal from '../Modal/ConfirmDeleteModal/ConfirmDeleteModal'; // Ensure this path is correct
import './Environments.css';
import { useTheme } from '../ThemeContext';
import { useAuth } from '../../context/AuthContext';
import ApiClient from '../../api/apiClient';
import { useData } from '../../context/DataContext';


const Phases = () => {
  const { environments, refreshEnvironments } = useData();
  const [phases, setPhases] = useState([]);
  const [error, setError] = useState('');
  const [updateResult, setUpdateResult] = useState('');
  const [showAddPhaseModal, setShowAddPhaseModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [phaseToDelete, setPhaseToDelete] = useState(null);
  const { theme } = useTheme();
  const { user } = useAuth();


  useEffect(() => {
    setPhases(environments || []);
  }, [environments]);

  // Delete phase
  const handleDeletePhase = async () => {
    try {
      const response = await ApiClient.delete(`/api/env/${phaseToDelete._id}`, { params: { organization: user?.organization || 'default' } });
      if (response.status === 200) {
        setUpdateResult('Environment deleted successfully');
        await refreshEnvironments(); // Refresh the phase list
        setTimeout(() => setUpdateResult(''), 3000); // Hide success message after 3 seconds
        setPhaseToDelete(null); // Clear selected phase
      }
    } catch (err) {
      setError('Error deleting Environment');
      setTimeout(() => setError(''), 3000); // Hide error message after 3 seconds
    } finally {
      setShowConfirmDeleteModal(false); // Hide confirmation modal
    }
  };

  // Show confirmation modal
  const confirmDeletePhase = (phase) => {
    setPhaseToDelete(phase);
    setShowConfirmDeleteModal(true);
  };

  const totalPhases = phases.length;

  return (
    <div className={`Environments-container ${theme}`}>
      <Navbar />
      <div className="Environments-content page-transition">
        <div className="page-shell panel">
          <div className="env-header">
            <div>
              <h1 className="page-title">Environments</h1>
              <p className="env-subtitle">Manage deployment phases and assign servers.</p>
            </div>
            <div className="env-actions">
              <div className="env-chip">Total: {totalPhases}</div>
              <button className="addnew-button" onClick={() => setShowAddPhaseModal(true)}>
                + Add Environment
              </button>
            </div>
          </div>

          {error && <div className="notification error">{error}</div>}
          {updateResult && <div className="notification success">{updateResult}</div>}

          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Available Environments</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {phases.map(phase => (
                  <tr key={phase._id}>
                    <td>{phase.name}</td>
                    <td>
                      <button
                        className="delete-button"
                        onClick={() => confirmDeletePhase(phase)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
                {!phases.length && (
                  <tr>
                    <td colSpan="2" className="empty-state">No environments yet.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <AddPhase
        show={showAddPhaseModal}
        onClose={() => setShowAddPhaseModal(false)}
        onPhaseAdded={refreshEnvironments} // Refresh after adding a new phase
      />

      <ConfirmDeleteModal
        show={showConfirmDeleteModal}
        onClose={() => setShowConfirmDeleteModal(false)}
        onConfirm={handleDeletePhase}
        phase={phaseToDelete}
      />
    </div>
  );
};

export default Phases;
